<!-- eslint-disable -->
<template>
  <div id="onlinestate">
    <div class="row align-items-start pb-2 pt-2">  
      <div class="col-1 d-flex justify-content-end label__adjust">
        Jahr: 
      </div>
      <div class="col-1 d-flex justify-content-start">            
           <select class="form-select select__max" v-model="selectedYear" @change="getSelectedYear">
              <option v-for="(item , idYear) in years" v-bind:key="idYear">
                {{item.year}}
              </option>
            </select>      
      </div>
      <div class="col-1">        
        <button
          type="button"
          @click.prevent="onButtonRefresh"
          class="btn btn-outline-primary same__size"
        >
        Anzeigen
        </button>
      </div>

      <div class="col-1">
        <span v-if="selectCount==1">
          {{selectedBereich}}
        </span>
        <span v-if="selectCount!=1">
          &nbsp;&nbsp;&nbsp;Sel.: {{selectCount}}
        </span>

      </div>

     

      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonEmergencyDataCreate"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Rett.erzeugen
        </button>
      </div>

      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonEmergencyData"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Rett.senden
        </button>
      </div>


      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonCreateRequisition"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Best.erzeugen
        </button>
      </div>

      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonShipRequisition"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Best.senden
        </button>
      </div>


      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonCreateInvoice"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Rech.erzeugen
        </button>
      </div>

      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonShipInvoice"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Rech.senden
        </button>
      </div>

      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonCreateReminder"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Mahnung.erzeugen
        </button>
      </div>

      <div class="col-1">
        <button
          type="button"
          @click.prevent="onButtonShipReminder"
          class="btn btn-outline-primary same__size"
          :disabled="isActionPossible()"
        >
        Mahnung.senden
        </button>
      </div>




      <!--div class="col-1 d-flex justify-content-end">
        <label class="checkbox__adjust">
            &nbsp;&nbsp;Überschreiben
        </label>
      </div-->      

      <!--div class="col-1 d-flex justify-content-start">
        <div class="checkbox checkbox-danger">
          <input id="chkOverwrite" v-bind="overwrite" class="styled form-switch" type="checkbox" @change="getOverWrite" unchecked />
        </div>      
      </div-->         
    </div>

    <div class="row align-items-start pb-2">
      <div clas="col-12">
        <document-access :customerLink="customerLink" :Year="selectedYear" :standAlone="documentStandAlone" />
      </div>
    </div>

    <div class="row align-items-start pb-2">
      <div clas="col-12">
        <Grid
          ref="grid"
          :style="{ height: '900px' }"
          :selected-field="selectedField"
          :data-items="filteredData"
          :columns="columns"
          :filterable="true"
          :filter="filter"
          :sortable="true"
          :sort="sort"
          @selectionchange="onSelectionChange"
          @headerselectionchange="onHeaderSelectionChange"
           @rowclick="onRowClick"
          @filterchange="filterChange"
          @sortchange="sortChange"
          :filter-cell-render="filterRender"
          @custom="customHandler"          
        >
          <template v-slot:checkBoxColumn="{ props }">
            <td>              
              <input type="checkbox" v-model="props.dataItem.bezahlt"
              @click="onCheckClick(props.dataItem)" 
              />
            </td>
          </template>             
          <template v-slot:bestellungPrint="{ props }">
            <td>
              <button type="button"
               @click.prevent="onBestellungDownload(props.dataItem)"
                class="btn btn-outline-primary">
                  Anzeigen
              </button>
            </td>
          </template>
          <template v-slot:rechnungPrint="{ props }">
            <td>
              <button type="button"
               @click.prevent="onRechnungDownload(props.dataItem)"
                class="btn btn-outline-primary">
                  Anzeigen
              </button>
            </td>
          </template>
          <template v-slot:actionColumn="{ props }">
            <td>
              <button type="button"
               @click.prevent="onActionClick(props.dataItem)"
                class="btn btn-outline-primary">
                  Details
              </button>
            </td>
          </template>
          <template v-slot:myTemplate="{ props }">
            <document-link-container :data-item="props.dataItem" />
          </template>
          <template v-slot:filterSlotTemplate="{ props }">
            <div>
              <input
                type="text"
                :value="props.value"
                @input="
                  (ev) => {
                    props.onChange({
                      operator: 'contains',
                      field: props.field,
                      value: ev.target.value,
                      syntheticEvent: ev,
                    });
                  }
                "
                style="width: 120px"
              />
              <button
                @click="
                  (ev) => {
                    props.onChange({
                      operator: '',
                      field: '',
                      value: '',
                      event: ev,
                    });
                  }
                "
              >
                Clear
              </button>
            </div>
          </template>
        </Grid>
      </div>
    </div>
  </div>
  <div v-if="spinner" class ="spinner__centered">
    <img src="img/icon/icons8-spinner.gif" alt="Bitte warten ...">
  </div>

</template>

<script>
import { Grid } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import DocumentAccess from "./DocumentAccess.vue";
import DocumentLinkContainer from "@/components/ControlCenter/DocumentLinkContainer.vue";

// Kunde --> Bestellanforderung
// Rechnung an Faktura und an Kunde
// Zahlung Checkbox
 
export default {
  name: "CreateCustomerDocuments",
  inheritAttrs: false,
  components: {
    Grid,
    DocumentAccess,
    DocumentLinkContainer,
  },
  data: function () {
    return {
      currentSelectedItem: undefined,
      selectCount: 0,
      selectedBereich: "",
      documentStandAlone: false,
      spinner: false,
      customerLink: "-",
      overwrite: false,
      selectedYear: 2026,
      selectedMandant: "02 SOS24Aid-Süd",
      mandants: [
        {idMandant:1073741838 , mandant: '01 SOS24Aid-Nord'},
        {idMandant:1073741959 , mandant: '02 SOS24Aid-Süd'}
      ],
      selected: {},
      years: [
        {idYear: 1, year: 2021},
        {idYear: 2, year: 2022},
        {idYear: 3, year: 2023},
        {idYear: 4, year: 2024},
        {idYear: 5, year: 2025},
        {idYear: 6, year: 2026},
      ],
      filter: {},
      sort: [
        { field: "nameMandant", dir: "asc" },
        { field: "nameBereich", dir: "asc" },
        { field: "bereichGruppierung", dir: "asc" },
      ],
      selectedField: "selected",
      filteredData: [],
      originData: [],
      staticColumns: [ 
        { field: 'kundenLink', title: 'Kunden-Link',  width:'100px',  filterable: false, hidden: false, cell: "actionColumn" },
        { field: 'nameMandant', title: 'Mandant', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'idBereich', title: 'Bestellung', width:'100px',  filterable: false, hidden: false, cell: "bestellungPrint" },
        { field: 'idMandant', title: 'Rechnung', width:'100px',  filterable: false, hidden: false, cell: "rechnungPrint" },
        { field: 'nameBereich', title: 'Bereich', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'status', title: 'Status', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'vorgangTyp', title: 'Typ', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'versandArt', title: 'Versandart', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'rechnungsBetrag', title: 'Betrag' ,filterable: false, sortable: false, width:'180px' },
        { field: 'bezahlt', title: 'Bezahlt', cell: "checkBoxColumn", filterable: false, width:'100px' },
        { field: 'hauptNameBereich', title: 'Haupt-Bereich', filterCell: 'filterSlotTemplate', width:'180px', hidden: true },
        { field: 'emailKundeBereich', title: 'Email-Kunde', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'emailFakturaBereich', title: 'Email-Faktura', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'kundeGruppen', title: 'Kunde-Gruppe', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'fakturaGruppen', title: 'Faktura-Gruppe', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'kundeNutzerprofil', title: 'Kunde-Nutzerprofil', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'fakturaNutzerProfil', title: 'Faktura-NutzerProfil', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'idVorgang', title: 'IdVorgang', filterable: false, hidden: true },
        { field: 'fkVorgangsTypCodeVerzeichnis', title: 'fkVorgangsTypCodeVerzeichnis', filterable: false, hidden: true },
        { field: 'jahr', title: 'Jahr', filterCell: 'filterSlotTemplate', width:'300px', hidden: true },
        { field: 'datumZeitLetzterKundenZugriff', title: 'Letzter Kundenzugriff', filterable: true, width:'180px' },
        { field: 'datumZeitErzeugung', title: 'DatumZeitErzeugung', filterable: true, width:'180px', hidden: true },
        { field: 'datumZeitBestellanfrageErzeugung', title: 'Bestellanfrage erzeugt', filterable: true, width:'180px' },
        { field: 'datumZeitLetzteBestellanfrageVersand', title: 'Bestellanfrage versand', filterable: true, width:'180px' },
        { field: 'datumZeitBestellnummerVerfuegbar', title: 'Bestellnummer verfuegbar', filterable: true, width:'180px' },
        { field: 'datumZeitRechnungErzeugt', title: 'Rechnung erzeugt', filterable: true, width:'180px' },
        { field: 'datumZeitRettungsdatenErzeugt', title: 'Rettungsdaten erzeugt', filterable: true, width:'180px' },
        { field: 'datumZeitLetzterRechnungVersand', title: 'Rechnung versand', filterable: true, width:'180px' },
        { field: 'bemerkung', title: 'Bemerkung', filterCell: 'filterSlotTemplate', width:'300px' },
        { field: 'fkHauptBereich', title: 'fkHauptBereich', filterable: false, hidden: true },
        { field: 'fkSprachCodeTabelle', title: 'fkSprachCodeTabelle', filterable: false, hidden: true },
        { field: 'Sprache', title: 'Sprache', filterable: true, width:'180px' },
        { field: 'fkDokumentVersandArtCodeVerzeichnis', title: 'fkDokumentVersandArtCodeVerzeichnis', filterable: false, hidden: true },
        { field: 'kundePersonen', title: 'KundePersonen', width:'180px' ,filterable: false, hidden: true},
        { field: 'fakturaPersonen', title: 'FakturaPersonen',  width:'180px',  filterable: false, hidden: true },
       
      ],
    };
  },
  computed: {
    areAllSelected() {
      try {
        if (this.filteredData.length == 0) {
          return false;
        }
        return this.filteredData.findIndex((item) => item.selected === false) === -1        
      } catch (e) {
        console.log(e);
      }
      return false;
    },
    columns() {
      return [
        {
          field: "selected",
          width: "50px",
          filterable: false,
          headerSelectionValue: this.areAllSelected,
        },
        ...this.staticColumns,
      ];
    },
  },
  methods: {

   isActionPossible() {
    const currentYear = new Date().getFullYear();
    if ( currentYear == this.selectedYear) {
      return false;
    }
    return true;

   },

   async setBezahlt(item) {
      try {
        this.spinner = true;
        const bezahlt = item.bezahlt;
        const idBereich = item.idBereich;
        const temp = await apiPost("ComponentView/setPaid", {
          userId: this.$store.getters["userstore/getUser"],
          bezahlt: bezahlt,
          idBereich: idBereich,
      });
      console.log(temp);      
      } catch (e) {
        console.log(e);
      }
      this.refreshCustomerLinks();
      this.spinner = false;

    },

    onCheckClick(item) {
      item.bezahlt = !item.bezahlt;
      this.setBezahlt(item);
    },

    onActionClick(item) {
      try {
        if ( this.customerLink.indexOf("###") >= 0) {
          this.customerLink = item.kundenLink.replace("###", "");
        } else {
        this.customerLink = item.kundenLink + "###";
        }
        this.currentSelectedItem = item;
      }
      catch(e) {
        console.log(e);
      }
    },
    
    onButtonCalculateReminders() {
      this.calculateReminders();
    },

    async calculateReminders() {
      try {
        this.spinner = true;
        const temp = await apiPost("ComponentView/mahnungslauf", {
          UserId: this.$store.getters["userstore/getUser"],
          Year: 2026,
          NameMandant: this.selectedMandant,
      });
      console.log(temp);      
      } catch (e) {
        console.log(e);
      }
      this.refreshCustomerLinks();
      this.spinner = false;

    },

    onBestellungDownload(item) {
      this.createCustomerPaperDocument(item,270, "Bestellung_Papier", true, "Snagit 2021" );
    },

    onRechnungDownload(item) {
      this.createCustomerPaperDocument(item,271, "Rechnung_Papier", true, "Snagit 2021" );
    },

    onButtonRefresh() {
      this.getData();
    },

    onButtonCreateRequisition() {
      this.createCustomerReports("BANF erzeugen");      
    },

    onButtonShipRequisition() {
      this.createCustomerReports("EMail.Bestellanforderung");
    },

    onButtonCreateInvoice() {
      this.createCustomerReports("Rechnung erzeugen");
      //this.createCustomerPaperDocuments(271,"RechnbungPapier" , true, "Microsoft Print to PDF");
    },

    onButtonCreateReminder() {
      this.createCustomerReports("Mahnung erzeugen");
      //this.createCustomerPaperDocuments(271,"RechnbungPapier" , true, "Microsoft Print to PDF");
    },

    onButtonShipReminder() {
      this.createCustomerReports("EMail.Mahnung");
    },

    onButtonShipInvoice() {
      this.createCustomerReports("EMail.Rechnung");
    },

    onButtonEmergencyData() {
      this.createCustomerReports("EMail.Rettungsdaten");
    },

    onButtonEmergencyDataCreate() {
      this.createCustomerReports("Rettungsdaten.Erzeugen"); 
    },

    refreshCustomerLinks() {
      try {
        if(this.currentSelectedItem === undefined || this.currentSelectedItem.kundenLink === undefined ) {
          return;
        }

        if ( this.customerLink.indexOf("###") >= 0) {
          this.customerLink = this.currentSelectedItem.kundenLink.replace("###", "");
        } else {
        this.customerLink = this.currentSelectedItem.kundenLink + "###";
        }      
      }
      catch(e) {
        console.log(e);
      }
    },

    

    onHeaderSelectionChange(event) {
      this.selectCount = 0;
      this.selectedBereich = "";
      let checked = event.event.target.checked;      
      this.filteredData = this.filteredData.map((item) => {
        return { ...item, selected: checked };
      });
      this.selected.records = []
      let i = 0;
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          this.selected.records.push(item);
          i = i + 1;
        }
      });
      this.selectCount = i;
      if (i == 1) {
         this.selectedBereich = this.selected.records[0].nameBereich;
      }
      else {
        this.selectedBereich ="";
      }

    },
    onSelectionChange(event) {
      this.selectionChanged(event);
    },

    selectionChanged( event ) {
      this.selectCount = 0;
      this.selectedBereich = "";
      if ( event.dataItem[this.selectedField] !== undefined) {
        event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
      }
      else {
        event.dataItem[this.selectedField] = true;
      }

      if (this.selected === undefined) {
        this.selected.records = [];
      }

      if (this.selected.records === undefined) {
        this.selected.records = [];
      }

      let i = 0;
      this.selected.records = [];
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          this.selected.records.push(item);
          i = i + 1;
        }
      });
      this.selectCount = i;
      if (i == 1) {
         this.selectedBereich = this.selected.records[0].nameBereich;
      }
      else {
        this.selectedBereich ="";
      }
    },
    onRowClick(event) {
      //this.customerLink = event.dataItem.kundenLink;
      //this.selectionChanged(event);
    },

    getSelectedYear() {
      console.log(this.selectedYear);
    },

    getSelectedMandant() {
      console.log(this.selectedMandant);
    },

    getOverWrite() {
      this.overwrite = !this.overwrite;
      console.log(this.overwrite);
    },

    filterChange: function (ev) {
      this.selectCount = 0;
      this.selectedBereich = "";
      this.filter = ev.filter;
      this.filteredData = filterBy(this.originData, this.filter);
    },
    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },
    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.filteredData, this.sort);
    },
    async getData() {
      this.selectCount = 0;
       this.selectedBereich = "";
      this.spinner = true;
      const temp = await apiPost("ComponentView/getCustomerProcesses", {
        userId: this.$store.getters["userstore/getUser"],
        year: this.selectedYear,
        overwrite: this.overwrite,
        action: "view",
      });
      this.filteredData = temp.map((item) => {
        return { ...item };
      });
      this.originData = temp.map((item) => {
        return { ...item };
      });

      try {
        this.filteredData = filterBy(this.originData, this.filter);
         this.filteredData = orderBy(this.filteredData, this.sort);
      } 
      catch( e ) {
        console.log(e);
      }

      this.spinner = false;
    },

 async createCustomerPaperDocument(record, documentType, action, isPrint, printerName) {
      try {
        this.spinner = true;
        const docFilePath = process.env.VUE_APP_FILEPATH;
        const docUrl = process.env.VUE_APP_DOCUMENTURL;
        const customerLink = process.env.VUE_APP_CUSTOMERLINKURL;
        let records = [];
        records.push(record);

        const temp = await apiPost("ComponentView/createCustomerPaperDocuments", {
          userId: this.$store.getters["userstore/getUser"],
          year: this.selectedYear,
          action: action,
          documentFilePath: docFilePath,
          documentUrl: docUrl,
          documentType: documentType,
          print: false,
          printerName: printerName,
          records: records,
      });
      this.refreshCustomerLinks();

      console.log(temp.documentUrl);

      const timerId = setTimeout(() => { this.openLink(temp.documentUrl) }, 100);
      

      } catch (e) {
        console.log(e);
      }
    
      this.spinner = false;

    },

    openLink (link) {   
          window.open(link, "_blank");    
      },

    async createCustomerPaperDocuments(documentType, action, isPrint, printerName) {
      try {
        this.spinner = true;
        const docFilePath = process.env.VUE_APP_FILEPATH;
        const docUrl = process.env.VUE_APP_DOCUMENTURL;
        const customerLink = process.env.VUE_APP_CUSTOMERLINKURL;
        const temp = await apiPost("ComponentView/createCustomerPaperDocuments", {
          userId: this.$store.getters["userstore/getUser"],
          year: this.selectedYear,
          action: action,
          documentFilePath: docFilePath,
          documentUrl: docUrl,
          documentType: documentType,
          print: isPrint,
          printerName: printerName,
          records: this.selected.records,
      });
      console.log(temp);      
      } catch (e) {
        console.log(e);
      }
      this.refreshCustomerLinks();
      this.spinner = false;

    },


    async createCustomerReports(action) {
      try {
        this.spinner = true;
        const docFilePath = process.env.VUE_APP_FILEPATH;
        const docUrl = process.env.VUE_APP_DOCUMENTURL;
        const customerLink = process.env.VUE_APP_CUSTOMERLINKURL;
        const temp = await apiPost("ComponentView/createCustomerReports", {
          userId: this.$store.getters["userstore/getUser"],
          year: this.selectedYear,
          overwrite: this.overwrite,
          action: action,
          documentFilePath: docFilePath,
          documentUrl: docUrl,
          records: this.selected.records,
          CustonerLinkBasePath: customerLink,
      });
      console.log(temp);      
      } catch (e) {
        console.log(e);
      }
      this.refreshCustomerLinks();
      this.spinner = false;

    },

    customHandler: function (e) {
      console.log("customHandler", e);
    },
    created() {
      this.selected.records = [];
    },
  },
};
</script>

<style scoped language="scss">
.spinner__centered {
  position: fixed;
  left: 460px;
  top: 400px;
  z-index: 999;
}

.k-grid {
  font-size: 12px !important;
}
.select__max {
  max-width: 120px;
  min-width: 120px;
}

.select__max-mandant
{
  margin-left: 2px;
  max-width: 340px;
  min-width: 340px;
}

.label__adjust {
  margin-top: 5px;
}

.form-switch {
    border-radius: 2em;
    height: 25px;
    width: 25px;
}

.checkbox__adjust{
  margin-top: 3px;
}

.left_offset{
  margin-left: 14px;
}

.same__size {
  min-width: 105px;
  padding-left: 5px;
  padding-right: 5px;
}

</style>